import { combineReducers } from 'redux';
import { BROKERBANS_ADV } from './types';
var brokerBansAdv = function (state, action) {
    if (state === void 0) { state = { options: [], trans: {} }; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case BROKERBANS_ADV:
            return payload;
        default:
            return state;
    }
};
export var SCOPE_NAME = 'ADV';
var ADV = combineReducers({
    brokerBansAdv: brokerBansAdv,
});
export default ADV;
